// extracted by mini-css-extract-plugin
export default {"cloud":"Cloud_cloud__FtCgx","content":"Cloud_content__sBx2F"};